import { IDeserialize } from "../abstraction/IDeserialize";
import { ChangelogType } from "../Enums";
import { ChangeCategory } from "./ChangeCategory";
import { Parsed } from "./Parsed";

export class Version implements IDeserialize<Version> {
  body = "";
  date = "";
  title = "";
  version = null;
  parsed: Parsed = new Parsed();
  changelogs: ChangeCategory[] = [];

  deserialize(version: Version): Version {
    Object.assign(this, version);

    // update the title (remove date and any other information except version )
    this.title = this.title.split(" ")[0];

    if (version.parsed) {
      this.changelogs = [];
      if (version.parsed.Added && version.parsed.Added.length) {
        const log = new ChangeCategory();
        log.title = ChangelogType.Added;
        version.parsed.Added.forEach((a) => {
          log.logs.push(a);
          version.parsed._ = version.parsed._.filter((b: string) => b !== a);
        });
        this.changelogs.push(log);
      }

      if (version.parsed.Changed && version.parsed.Changed.length) {
        const log = new ChangeCategory();
        log.title = ChangelogType.Changed;
        version.parsed.Changed.forEach((a) => {
          log.logs.push(a);
          version.parsed._ = version.parsed._.filter((b: string) => b !== a);
        });
        this.changelogs.push(log);
      }

      if (version.parsed.Deprecated && version.parsed.Deprecated.length) {
        const log = new ChangeCategory();
        log.title = ChangelogType.Deprecated;
        version.parsed.Deprecated.forEach((a) => {
          log.logs.push(a);
          version.parsed._ = version.parsed._.filter((b: string) => b !== a);
        });
        this.changelogs.push(log);
      }

      if (version.parsed.Fixed && version.parsed.Fixed.length) {
        const log = new ChangeCategory();
        log.title = ChangelogType.Fixed;
        version.parsed.Fixed.forEach((a) => {
          log.logs.push(a);
          version.parsed._ = version.parsed._.filter((b: string) => b !== a);
        });
        this.changelogs.push(log);
      }

      if (version.parsed.Removed && version.parsed.Removed.length) {
        const log = new ChangeCategory();
        log.title = ChangelogType.Removed;
        version.parsed.Removed.forEach((a) => {
          log.logs.push(a);
          version.parsed._ = version.parsed._.filter((b: string) => b !== a);
        });
        this.changelogs.push(log);
      }

      if (version.parsed.Security && version.parsed.Security.length) {
        const log = new ChangeCategory();
        log.title = ChangelogType.Security;
        version.parsed.Security.forEach((a) => {
          log.logs.push(a);
          version.parsed._ = version.parsed._.filter((b: string) => b !== a);
        });
        this.changelogs.push(log);
      }
    }

    return this;
  }
}
